import { appConfig } from '@/config/app'

export const CACHE_TTL_MS = appConfig.cache.defaultDurationMs

export const AUTH = {
  pendingPaymentCheckDelayMs: appConfig.auth.pendingPaymentCheckDelayMs,
  pendingPaymentTtlMs: appConfig.auth.pendingPaymentTtlMs,
} as const

export const UI = {
  copyToastDurationMs: appConfig.ui.copyFeedbackDurationMs,
} as const
